import { useNavigate } from 'react-router';
import { useOrder, useOrderRoute } from '../../contexts/OrderContext';

export function SurveyCtaBar() {
  const navigate = useNavigate();
  const { order } = useOrder();
  const orderRoute = useOrderRoute();

  const hasDiscountCode = order?.discountCode;

  const handleClick = async () => {
    if (hasDiscountCode) {
      navigate(orderRoute);
    }
    else {
      navigate('/survey');
    }
  };

  return (
    <div
      className="bg-[#005065] text-white cursor-pointer"
      onClick={handleClick}
    >
      <div className="container mx-auto px-4 py-2 text-center">
        {hasDiscountCode ? (
          <div className="flex items-center justify-center space-x-2">
            <span className="font-semibold text-sm">
              You've got 25% off your installation
            </span>
          </div>
        ) : (
          <div>
            <div className="font-semibold text-sm">
              Get 25% off your installation
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
